import React from 'react';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { RiEdit2Fill } from 'react-icons/ri';
import { useRouter } from '~/hooks';

const NextPrevious = ({ sections = [], submit , canSubmit }) => {
    const { pathname, replace } = useRouter();

    const sectionMatch = /\d\/(.*)$/i.exec(pathname);

    if (sectionMatch == null)
        return <></>;
        
    const currentSectionName = sectionMatch[1];
    const currentSection = sections.indexOf(currentSectionName);

    const hasPrev = currentSection > 0;
    const hasNext = currentSection < sections.length - 1;
    const isSubmit = pathname.includes('submit');
    
    const goToNext = () => {
        const next = sections[currentSection + 1];
        window.scrollTo(0, 0);
        replace(pathname.replace(`/${currentSectionName}`, `/${next}`));
    };

    const goToPrev = () => {
        const prev = sections[currentSection - 1];
        window.scrollTo(0, 0);
        replace(pathname.replace(`/${currentSectionName}`, `/${prev}`));
    };

    return (
        <div className='mt-auto pt-4 px-4 flex items-center'>
            {hasPrev && (
                <button 
                    className='flex items-center justify-center rounded-full py-2 px-3 pr-4 text-white bg-lightGreen-300 focus:outline-none'
                    onClick={goToPrev}
                >
                    <FiArrowLeft className="mr-1" size='1.5rem'/> Previous Section
                </button>
            )}
            {isSubmit ?
                <></>
                : (hasNext 
                    ? (
                        <button 
                            id="next-section-button"
                            className='ml-auto flex items-center justify-center rounded-full py-2 px-3 pl-4 text-white bg-lightGreen-300 focus:outline-none'
                            onClick={goToNext}
                        >
                            Next Section <FiArrowRight className="ml-1" size='1.5rem'/>
                        </button>

                    ) : (canSubmit ?
                        <button 
                            className='ml-auto flex items-center justify-center rounded-full py-2 px-3 pl-4 text-white bg-lightGreen-300 focus:outline-none'
                            onClick={submit}
                        >
                            Submit <RiEdit2Fill size='1.125em' className='ml-1'/>
                        </button>
                        :
                        <></>
                    ))       
            }
        </div>
    );
};

export default NextPrevious;